export default __webpack_public_path__ + "static/media/Beehaz_02_front_desk.10e5a51b.png";